import React from 'react';
import FieldSettings from './FieldSettings';

export default ({ children, field, group }) => (
  <FieldSettings.Consumer>
    {fields => {
      if (!fields[group] || !fields[group].fields || !fields[group].fields[field]) {
        return <p>Invalid field group or key</p>;
      } else if (fields[group].fields[field].visible) {
        return children;
      }
    }}
  </FieldSettings.Consumer>
);
